import { AbstractManifestMiddleware } from './AbstractManifestMiddleware';
import type { InlineElement } from '@wix/component-protocol/schema';
import { DisplayValueEnumDisplayValue } from '@wix/ambassador-devcenter-v1-component-type-data/types';

export class RefElementDisplayMiddleware extends AbstractManifestMiddleware {
  resolveRootElement: AbstractManifestMiddleware['resolveRootElement'] = () => {
    return null;
  };

  resolveChildRefElement: AbstractManifestMiddleware['resolveChildRefElement'] =
    (node) => {
      const manifest = node.getManifest();
      const behaviors =
        (manifest?.editorElement as InlineElement)?.behaviors ?? {};

      if (!behaviors.removable) {
        return null;
      }

      const cssProperties = manifest?.editorElement?.cssProperties ?? {};
      const displayCssPropertyDefinition = cssProperties.display;

      const displayValues =
        displayCssPropertyDefinition?.display?.displayValues ?? [];

      const isNoneDefined = displayValues.includes(
        DisplayValueEnumDisplayValue.none,
      );

      if (isNoneDefined) {
        return null;
      }

      return {
        cssProperties: {
          display: {
            display: {
              displayValues: [
                ...displayValues,
                DisplayValueEnumDisplayValue.none,
              ],
            },
          },
        },
      };
    };
}
